module.exports = __webpack_public_path__ + "img/umbrella.dc40f354.jpg";